import { render, staticRenderFns } from "./DashboardItemCard.vue?vue&type=template&id=8da3e298&scoped=true"
import script from "./DashboardItemCard.vue?vue&type=script&lang=js"
export * from "./DashboardItemCard.vue?vue&type=script&lang=js"
import style0 from "./DashboardItemCard.vue?vue&type=style&index=0&id=8da3e298&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da3e298",
  null
  
)

export default component.exports